import { type FC } from 'react';

export const TracexLogo: FC<{ className?: string }> = ({ className }) => (
  <img src="/integrations/tracex-logo.png" alt="TraceX" className={className} />
);
